// extracted by mini-css-extract-plugin
module.exports = {"main-component":"userFeedback_main-component__12mGo"};